//Hook recebe de parametro o nome do cadastro e retorna um objeto com as permissoes do usuario
interface IPermissions {
  register: string
  show: boolean
  edit: boolean
  delete: boolean
  create: boolean
  role?: string
}

function usePermissions(name: string) {
  let permission: IPermissions = {
    register: 'none',
    show: false,
    edit: false,
    delete: false,
    create: false,
  }

  let getpermissions = []
  let roles = []
  let getpermissionsresp = localStorage.getItem('permissions_storage')
  if (getpermissionsresp) getpermissions = JSON.parse(getpermissionsresp)
  let getrolesresp = localStorage.getItem('roles_storage')
  if (getrolesresp) roles = JSON.parse(getrolesresp)
  permission.role = roles.name

  for (let index = 0; index < getpermissions.length; index++) {
    if (getpermissions[index].name.split(' - ')[0] === name) {
      permission.register = name
      if (getpermissions[index].name.split(' - ')[1] === 'Visualizar') permission.show = true
      if (getpermissions[index].name.split(' - ')[1] === 'Editar') permission.edit = true
      if (getpermissions[index].name.split(' - ')[1] === 'Apagar') permission.delete = true
      if (getpermissions[index].name.split(' - ')[1] === 'Criar') permission.create = true
    }
  }

  return permission
}
export {usePermissions}
